// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","siteTitle":"Footer_siteTitle__p-BO7","icon":"Footer_icon__Zscac","link":"Footer_link__3Ie8d","copyright":"Footer_copyright__JQMtz"};